"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectTranslationsValues = exports.selectTranslationsInterface = exports.selectTranslations = exports.selectLocales = exports.selectAllByTranslations = exports.selectActiveTranslationsValues = exports.selectActiveTranslationsInterfaceUILocalizations = exports.selectActiveTranslationsInterfaceUIInfo = exports.selectActiveTranslationsInterfaceUIComponentInfo = exports.selectActiveTranslationsInterfaceUI = exports.selectActiveTranslationsInterface = exports.selectActiveTranslations = exports.getTranslationsValues = exports.getTranslationsInterface = exports.getTranslations = exports.getLocales = exports.getAllByTranslations = exports.getActiveTranslationsValues = exports.getActiveTranslationsInterfaceUILocalizations = exports.getActiveTranslationsInterfaceUIInfo = exports.getActiveTranslationsInterfaceUIComponentInfo = exports.getActiveTranslationsInterfaceUI = exports.getActiveTranslationsInterface = exports.getActiveTranslations = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _constants = require("../../../utils/constants");
/** @deprecated getTranslationsInterface use selectTranslationsInterface */
const getTranslationsInterface = _ref => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref;
  return (translations === null || translations === void 0 ? void 0 : translations.total.interface) || {};
};
/** @deprecated getTranslationsValues use selectTranslationsValues */
exports.getTranslationsInterface = getTranslationsInterface;
const getTranslationsValues = _ref2 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref2;
  return (translations === null || translations === void 0 ? void 0 : translations.total.values) || {};
};
/** @deprecated getTranslations use selectTranslations */
exports.getTranslationsValues = getTranslationsValues;
const getTranslations = _ref3 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref3;
  return (translations === null || translations === void 0 ? void 0 : translations.total) || {};
};

/** @deprecated getActiveTranslationsInterface use selectActiveTranslationsInterface */
exports.getTranslations = getTranslations;
const getActiveTranslationsInterface = _ref4 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref4;
  return (translations === null || translations === void 0 ? void 0 : translations.active.interface) || {};
};
/** @deprecated getActiveTranslationsInterfaceUILocalizations use selectActiveTranslationsInterfaceUILocalizations */
exports.getActiveTranslationsInterface = getActiveTranslationsInterface;
const getActiveTranslationsInterfaceUILocalizations = _ref5 => {
  var _translations$active$;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref5;
  return (translations === null || translations === void 0 || (_translations$active$ = translations.active.interface) === null || _translations$active$ === void 0 || (_translations$active$ = _translations$active$.UI) === null || _translations$active$ === void 0 ? void 0 : _translations$active$.Localizations) || {};
};
/** @deprecated getActiveTranslationsInterfaceUIInfo use selectActiveTranslationsInterfaceUIInfo */
exports.getActiveTranslationsInterfaceUILocalizations = getActiveTranslationsInterfaceUILocalizations;
const getActiveTranslationsInterfaceUIInfo = _ref6 => {
  var _translations$active$2;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref6;
  return (translations === null || translations === void 0 || (_translations$active$2 = translations.active.interface) === null || _translations$active$2 === void 0 || (_translations$active$2 = _translations$active$2.UI) === null || _translations$active$2 === void 0 ? void 0 : _translations$active$2.Info) || {};
};
/** @deprecated getActiveTranslationsInterfaceUIComponentInfo use selectActiveTranslationsInterfaceUIComponentInfo */
exports.getActiveTranslationsInterfaceUIInfo = getActiveTranslationsInterfaceUIInfo;
const getActiveTranslationsInterfaceUIComponentInfo = _ref7 => {
  var _translations$active$3;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref7;
  return (translations === null || translations === void 0 || (_translations$active$3 = translations.active.interface) === null || _translations$active$3 === void 0 || (_translations$active$3 = _translations$active$3.UI) === null || _translations$active$3 === void 0 ? void 0 : _translations$active$3.componentInformation) || {};
};
/** @deprecated getActiveTranslationsInterfaceUI use selectActiveTranslationsInterfaceUI */
exports.getActiveTranslationsInterfaceUIComponentInfo = getActiveTranslationsInterfaceUIComponentInfo;
const getActiveTranslationsInterfaceUI = _ref8 => {
  var _translations$active$4;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref8;
  return (translations === null || translations === void 0 || (_translations$active$4 = translations.active.interface) === null || _translations$active$4 === void 0 ? void 0 : _translations$active$4.UI) || {};
};
/** @deprecated getActiveTranslationsValues use selectActiveTranslationsValues */
exports.getActiveTranslationsInterfaceUI = getActiveTranslationsInterfaceUI;
const getActiveTranslationsValues = _ref9 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref9;
  return (translations === null || translations === void 0 ? void 0 : translations.active.values) || {};
};
/** @deprecated getActiveTranslations use selectActiveTranslations */
exports.getActiveTranslationsValues = getActiveTranslationsValues;
const getActiveTranslations = _ref10 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref10;
  return (translations === null || translations === void 0 ? void 0 : translations.active) || {};
};
/** @deprecated getAllByTranslations use selectAllByTranslations */
exports.getActiveTranslations = getActiveTranslations;
const getAllByTranslations = _ref11 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref11;
  return translations || {};
};
/** @deprecated getLocales use selectLocales */
exports.getAllByTranslations = getAllByTranslations;
const getLocales = _ref12 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref12;
  return translations.locale || null;
};
exports.getLocales = getLocales;
const selectTranslationsInterface = _ref13 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref13;
  return (translations === null || translations === void 0 ? void 0 : translations.total.interface) || {};
};
exports.selectTranslationsInterface = selectTranslationsInterface;
const selectTranslationsValues = _ref14 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref14;
  return (translations === null || translations === void 0 ? void 0 : translations.total.values) || {};
};
exports.selectTranslationsValues = selectTranslationsValues;
const selectTranslations = _ref15 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref15;
  return (translations === null || translations === void 0 ? void 0 : translations.total) || {};
};
exports.selectTranslations = selectTranslations;
const selectActiveTranslationsInterface = _ref16 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref16;
  return (translations === null || translations === void 0 ? void 0 : translations.active.interface) || {};
};
exports.selectActiveTranslationsInterface = selectActiveTranslationsInterface;
const selectActiveTranslationsInterfaceUILocalizations = _ref17 => {
  var _translations$active$5;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref17;
  return (translations === null || translations === void 0 || (_translations$active$5 = translations.active.interface) === null || _translations$active$5 === void 0 || (_translations$active$5 = _translations$active$5.UI) === null || _translations$active$5 === void 0 ? void 0 : _translations$active$5.Localizations) || {};
};
exports.selectActiveTranslationsInterfaceUILocalizations = selectActiveTranslationsInterfaceUILocalizations;
const selectActiveTranslationsInterfaceUIInfo = _ref18 => {
  var _translations$active$6;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref18;
  return (translations === null || translations === void 0 || (_translations$active$6 = translations.active.interface) === null || _translations$active$6 === void 0 || (_translations$active$6 = _translations$active$6.UI) === null || _translations$active$6 === void 0 ? void 0 : _translations$active$6.Info) || {};
};
exports.selectActiveTranslationsInterfaceUIInfo = selectActiveTranslationsInterfaceUIInfo;
const selectActiveTranslationsInterfaceUIComponentInfo = _ref19 => {
  var _translations$active$7;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref19;
  return (translations === null || translations === void 0 || (_translations$active$7 = translations.active.interface) === null || _translations$active$7 === void 0 || (_translations$active$7 = _translations$active$7.UI) === null || _translations$active$7 === void 0 ? void 0 : _translations$active$7.componentInformation) || {};
};
exports.selectActiveTranslationsInterfaceUIComponentInfo = selectActiveTranslationsInterfaceUIComponentInfo;
const selectActiveTranslationsInterfaceUI = _ref20 => {
  var _translations$active$8;
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref20;
  return (translations === null || translations === void 0 || (_translations$active$8 = translations.active.interface) === null || _translations$active$8 === void 0 ? void 0 : _translations$active$8.UI) || {};
};
exports.selectActiveTranslationsInterfaceUI = selectActiveTranslationsInterfaceUI;
const selectActiveTranslationsValues = _ref21 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref21;
  return (translations === null || translations === void 0 ? void 0 : translations.active.values) || {};
};
exports.selectActiveTranslationsValues = selectActiveTranslationsValues;
const selectActiveTranslations = _ref22 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref22;
  return (translations === null || translations === void 0 ? void 0 : translations.active) || {};
};
exports.selectActiveTranslations = selectActiveTranslations;
const selectAllByTranslations = _ref23 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref23;
  return translations || {};
};
exports.selectAllByTranslations = selectAllByTranslations;
const selectLocales = _ref24 => {
  let {
    [_constants.packageKey]: {
      translations
    } = {}
  } = _ref24;
  return translations.locale || null;
};
exports.selectLocales = selectLocales;